// extracted by mini-css-extract-plugin
export var originalPrice = "_wc-0";